import React, { useState } from 'react'

import { Copy } from '@mondough/copy'

import { TabCreatorReferral } from '../utils'

type ReferralContextType = {
  referralData: TabCreatorReferral | null
  setReferral: (referral: TabCreatorReferral | null) => void
  defaultReferralText: string | React.ReactNode
}

export const ReferralContext = React.createContext<ReferralContextType>({
  referralData: null,
  setReferral: () => {},
  defaultReferralText: null,
})

export const ReferralProvider = ({ children }: { children: JSX.Element }) => {
  const [referralData, setReferralData] = useState<TabCreatorReferral | null>(
    null,
  )

  const defaultReferralText = (
    <Copy.Simple
      id="app_tabs_monzo_me.referral.default.description"
      fallback="Automate bills. Organise how you spend. Save in clever new ways, all with a free Monzo current account.\n\nYour information from Monzo Split will be there when you join.\n\nTs&Cs apply."
      preserveNewlines
    />
  )

  return (
    <ReferralContext.Provider
      value={{
        referralData,
        setReferral: setReferralData,
        defaultReferralText,
      }}
    >
      {children}
    </ReferralContext.Provider>
  )
}
